import { Button, Result } from 'antd';
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from '../components/Loading';
import { CHANGE_PASSWORD_PATH } from './AuthProvider';
import useAuth from './useAuth';

// allows access to users who are authenticated; anyone else is sent to sign in
// and returns to the route they asked for
function ProtectedRoute() {
  const { isAuthenticated, isLoading, authError, mustChangePassword, loginWithRedirect } =
    useAuth();

  useEffect(() => {
    // Don't bounce back to QuestionPro when the last attempt just failed -
    // that turns a bad client/callback configuration into a redirect loop.
    if (!isLoading && !isAuthenticated && !authError) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, authError, loginWithRedirect]);

  if (!isLoading && authError) {
    return (
      <Result
        status="error"
        title="Could not sign you in"
        subTitle={authError}
        extra={
          <Button type="primary" onClick={() => loginWithRedirect()}>
            Try again
          </Button>
        }
      />
    );
  }

  if (isLoading || !isAuthenticated) {
    return <Loading />;
  }

  // The API rejects every other call while this is pending, so there is no
  // point rendering a page that can only fill with errors.
  if (mustChangePassword) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
